module.exports = __webpack_public_path__ + "media/10no-seven.aa545d27.mp3";